import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    select: { width: 200 },
    selectorGrid: {
      justifyContent: 'end',
      display: 'flex',
    },
    inputLabel: { backgroundColor: palette.white, padding: '0px 4px' },
    headerText: { fontSize: 14, fontWeight: 550, wordBreak: 'break-all' },
    maintenanceTitleGrid: {
      borderRadius: '8px 8px 0px 0px',
      backgroundColor: palette.grey300,
      marginTop: 8,
      cursor: 'pointer',
      paddingBottom: 5,
    },

    maintenanceTitleGridCollapsed: {
      borderRadius: 8,
      backgroundColor: palette.grey300,
      marginTop: 8,
      cursor: 'pointer',
      paddingBottom: 5,
    },
    maintenanceTitleValue: {
      fontSize: 14,
      fontWeight: 550,
      margin: 8,
      color: palette.grey800,
    },
    titleIcon: { fontSize: 15 },
    alert: {
      maxWidth: 500,
      width: 'fit-content',
      margin: '0 auto',
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },
    expandIcon: {
      margin: '-35px 0px 0px 0px',
      paddingRight: 8,
      paddingTop: 3,

      '& .MuiSvgIcon-root': { fontSize: 25 },
    },
    table: {
      minWidth: 650,
      height: 40,
    },
    cell: {
      wordBreak: 'break-all',
      maxWidth: 200,
      padding: '0px 8px',
    },
    tableRow: {
      height: 40,
      '& .MuiTableCell-sizeSmall:first-child': { paddingLeft: 16 },
    },
    cellChanged: {
      backgroundColor: palette.lightGreen,
      fontWeight: 550,
      color: palette.grey800,
    },
    cellBorder: {
      borderRight: `1px solid ${palette.grey300}`,
      borderLeft: `1px solid ${palette.grey300}`,
    },
    cellTitle: { fontWeight: 550, color: palette.grey800 },
    container: {
      marginTop: 8,
      '& .MuiPaper-rounded': { borderRadius: '0px 0px 8px 8px' },
    },
    menuItem: { fontSize: 12, '& .MuiMenuItem-root': { fontSize: 12 } },
    formControl: {},
    subject: { fontSize: 16, color: palette.grey400, marginRight: 3 },
    textWithSubject: { display: 'flex', alignItems: 'center' },
    textValue: { fontSize: 12 },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: 600,
    overflowX: 'auto',
    maxWidth: 700,
  },
};
